export enum SessionStorageKeyEnum {
    STATE_MACHINE_CONFIG = 'otb-state-machine',
    STATE_MACHINE_LAST_STATE = 'otb-state-machine-last-state',
    BOOKING = 'otb-booking',
    TIMESTAMP = 'otb-timestamp',
    PERSONAL_DATA_FORM = 'otb-personal-data-form',
    APPLICATION_SETTINGS = 'otb-application-settings'
}
